import { useState } from 'react';
import { Trans } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import Button from '../../../components/mplat/Button/Button';
import { CreateButtonProps } from '../types';


export function CreateButton({ onClick, isEdit, hasChanges }: CreateButtonProps) {
    const { ref, inView } = useInView({
        threshold: 1
    });

    const [inAction, setIsAction] = useState(false);

    return (
        <div ref={ref} className={'content-add__submit' + (inView ? '' : ' _fixed')}>
            <div className="content-add__submit-inner">
                <Button
                    data-test-id="contentSaveButton"
                    type="submit"
                    disabled={inAction || !hasChanges}
                    onClick={(e) => onClick(e, setIsAction)}
                >
                    {isEdit ?
                        <Trans>Save</Trans>
                        :
                        <Trans>Create</Trans>
                    }
                </Button>
            </div>
        </div>
    );
}